import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import BlackFilledCrown from '../../assets/icons/freemium-plan/black-filled-crown.svg';
import useStyles from './index.styles';
import ModalUpgradePlan from '../ModalUpgradePlan';

const ButtonUpgradePlan = ({ size, ...props }) => {
    const styles = useStyles();
    const [isModalUpgradeOpen, setIsModalUpgradeOpen] = useState(false);

    const handleOpenModalUpgradePlan = (value) => {
        setIsModalUpgradeOpen(value);
    };

    return (
        <>
            <Button
                startIcon={
                    <span style={{ display: 'flex' }}>
                        <img src={BlackFilledCrown} alt="icon" />
                    </span>
                }
                variant="outlined"
                className={styles.upgradePlanButton}
                size={size || 'medium'}
                onClick={() => handleOpenModalUpgradePlan(true)}
                {...props}
            >
                Mejorar mi plan
            </Button>
            <ModalUpgradePlan
                open={isModalUpgradeOpen}
                onClose={() => setIsModalUpgradeOpen(false)}
            />
        </>
    );
};

export default ButtonUpgradePlan;
